module.exports = __webpack_public_path__ + "static/media/slide-01.bca94844.jpg";